<script setup>
// RM-427: the optional RM via text choice on the application. Never ticked in
// advance; ticking it is the enrollment (the disclosure is the emailed
// invitation's). The wording comes from the server so the exact text shown is
// the text saved with the opt-in.
defineProps({
  modelValue: { type: Boolean, default: false },
  copy: { type: Object, required: true },
})

const emit = defineEmits(['update:modelValue'])
</script>

<template>
  <div class="sms-opt-in mb-4">
    <div class="d-flex align-start">
      <VCheckbox
        id="sms-opt-in"
        :model-value="modelValue"
        inline
        hide-details
        density="compact"
        style="margin-top: -6px;"
        @update:model-value="v => emit('update:modelValue', !!v)"
      />
      <VLabel
        for="sms-opt-in"
        class="sms-opt-in__label"
      >
        {{ copy.label }}
      </VLabel>
    </div>
    <p class="sms-opt-in__disclosure">
      {{ copy.disclosure }}
      <a
        :href="copy.termsUrl"
        target="_blank"
        rel="noopener noreferrer"
      >Terms</a>
      &middot;
      <a
        :href="copy.privacyUrl"
        target="_blank"
        rel="noopener noreferrer"
      >Privacy Policy</a>
    </p>
  </div>
</template>

<style lang="scss" scoped>
.sms-opt-in__label {
  opacity: 1;
  white-space: normal;
  flex: 1;
  text-align: left;
  font-size: 16px;
  line-height: 1.4;
  color: var(--ds-text-strong);
}

.sms-opt-in__disclosure {
  margin: 4px 0 0 36px;
  text-align: left;
  font-size: 12px;
  line-height: 1.5;
  color: var(--ds-text-muted);
}
</style>
